import { getDatalayer, trackTMSPage } from '../tag-commander/datalayer';
import { handleConfirmationTmsError } from './error';

export const trackTMSConfirmation = async () => {
  const product = getProduct();
  if (!product) {
    handleConfirmationTmsError('product');
    return;
  }
  const transactionId = getTransactionId();
  if (!transactionId) {
    handleConfirmationTmsError('transaction_id');
    return;
  }
  await trackTMSPage(
    {
      env_template: getEnvTemplate(product),
      page_name: 'confirmation',
    },
    { skipFetch: true }
  );
};

const getProduct = (): string | undefined => {
  const product = window?.tc_vars?.product;
  if (product) {
    return product;
  }
  return getDatalayer()?.product;
};

const getTransactionId = (): string | undefined => {
  const transactionId = window?.tc_vars?.transaction_id;
  if (transactionId) {
    return transactionId;
  }
  return getDatalayer()?.transaction_id;
};

const getEnvTemplate = (product: string) => {
  const dictionary = {
    DYNPACK: 'confirmation',
    PRIZE_FREEZE_FLIGHT: 'confirmation',
    FLIGHT: 'confirmation',
    TRAIN: 'confirmation',
    XFARING: 'confirmation',
    HOTEL: 'hotel-bf-confirmation',
    SUBSCRIPTION: 'confirmation',
    UPP: 'confirmation',
    'SEAT-PB': 'seat-PB',
    'BAG-PB': 'bag-PB',
    'INSURANCE-PB': 'check-in-PB',
  };
  return dictionary[product] || 'confirmation';
};
